export type AdminToastType = 'success' | 'error' | 'warning';

export interface AdminToastState {
    show: boolean;
    message: string;
    type: AdminToastType;
}

export const emptyAdminToast: AdminToastState = {
    show: false,
    message: '',
    type: 'success',
};
